<div *ngIf="isVisible" class="info-banner">
  <div class="info-banner__header">
    <div class="info-banner__icon">
      <mat-icon>warning</mat-icon>
    </div>
    <div class="info-banner__title">
      {{ 'MAINTENANCES.INFO_BANNER.TITLE' | translate }}
    </div>
    <button class="info-banner__close" (click)="hideBanner()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="info-banner__description">
    {{ 'MAINTENANCES.INFO_BANNER.DESCRIPTION' | translate }}
    <span class="content-link" (click)="openPreviousMaintenance()">
      {{ maintenance.number }}
      <mat-icon>open_in_new</mat-icon>
    </span>
  </div>
</div>
